// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__3Hdkj","Open":"SideDrawer_Open__6ke_k","Close":"SideDrawer_Close__3iitx","Logo":"SideDrawer_Logo__1ii0g"};